import proj4 from 'proj4';
import inside from '@turf/inside';

import { EPSG3067 } from '../../config';
import getProvinces from '../provinces';

export default function filterByProvince(event, val) {
  const eventCoord = proj4(EPSG3067, [parseFloat(event.LAT), parseFloat(event.LON)]);
  const insidePoint = { type: 'Feature', geometry: { type: 'Point', coordinates: eventCoord } };

  if (val === '0') {
    return true;
  }

  const province = getProvinces().find(prov => prov.properties.nimi === val);

  return inside(insidePoint, province);
}



// WEBPACK FOOTER //
// ./src/services/filters/filterByProvince.js